import { HttpAuth } from '../../config/Http'

export const actionTypes = {
    INDEX: 'CUPONS_INDEX',
    CHANGE: 'MENOR_CHANGE',
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

// INDEX

export const indexResponse = (payload) => ({
    type: actionTypes.INDEX,
    payload
})

export const index = (campaign_id = null, initial = null, final = null, type = 'menor', qtd = 1) => dispatch => {
    return HttpAuth.post('/menor/'+ campaign_id, {
        'initial' : initial,
        'final': final,
        'type' : type,
        'qtd' : qtd
    })
    .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
    .catch(error => dispatch(indexResponse({cotas: []})))
}